<div class="withSideNav">
    <div class="sideNav">
        <ul>
            <li>
                <a routerLink="/support">
                    <img
                        ngSrc="assets/images/icons/help.svg"
                        class="svgIcon"
                        width="300"
                        height="300"
                        alt=""
                    />
                    <ng-container i18n="@@support.home">Home</ng-container>
                </a>
            </li>
            <li *ngFor="let articleBranch1 of tree.children">
                <a
                    routerLink="/support/{{ articleBranch1.slug }}"
                    [class.active]="articleBranch1.slug === this.slugs[0]"
                    [class.deepestActive]="articleBranch1.slug === this.slugs[0] && this.slugs.length === 1"
                >
                    <mat-icon *ngIf="isMatIcon(articleBranch1.icon)">{{ articleBranch1.icon }}</mat-icon>
                    <img
                        *ngIf="!isMatIcon(articleBranch1.icon)"
                        ngSrc="assets/images/icons/{{ articleBranch1.icon }}"
                        class="svgIcon"
                        width="300"
                        height="300"
                        alt=""
                    />
                    {{ articleBranch1.title }}
                </a>

                <ul
                    *ngIf="
                        articleBranch1.children
                        && articleBranch1.children.length > 0
                        && articleBranch1.slug === this.slugs[0]
                    "
                >
                    <li *ngFor="let articleBranch2 of articleBranch1.children">
                        <a
                            routerLink="/support/{{ articleBranch1.slug }}/{{ articleBranch2.slug }}"
                            [class.active]="articleBranch2.slug === this.slugs[1]"
                            [class.deepestActive]="articleBranch2.slug === this.slugs[1] && this.slugs.length === 2"
                        >
                            <mat-icon *ngIf="isMatIcon(articleBranch2.icon)">{{ articleBranch2.icon }}</mat-icon>
                            <img
                                *ngIf="!isMatIcon(articleBranch2.icon)"
                                ngSrc="assets/images/icons/{{ articleBranch2.icon }}"
                                class="svgIcon"
                                width="300"
                                height="300"
                                alt=""
                            />
                            {{ articleBranch2.title }}
                        </a>

                        <ul
                            *ngIf="
                                articleBranch2.children
                                && articleBranch2.children.length > 0
                                && articleBranch2.slug === this.slugs[1]
                            "
                        >
                            <li *ngFor="let articleBranch3 of articleBranch2.children">
                                <a
                                    routerLink="/support/{{ articleBranch1.slug }}/{{ articleBranch2.slug }}/{{ articleBranch3.slug }}"
                                    [class.active]="articleBranch3.slug === this.slugs[2]"
                                    [class.deepestActive]="articleBranch3.slug === this.slugs[2] && this.slugs.length === 3"
                                >
                                    {{ articleBranch3.title }}
                                </a>
                        </ul>
                </ul>
            </li>
        </ul>
    </div>

    <div class="article supportArticleContent">
        <p class="mobileBackBtn">
            <a routerLink="/support{{ (slugs.length > 1) ? '/' + slugs[0] : '' }}{{ (slugs.length > 2) ? '/' + slugs[1] : '' }}" mat-stroked-button color="primary">
                <mat-icon>north_west</mat-icon> {{ parents[0].title }}
            </a>
        </p>

        <h1>{{ this.article.title }}</h1>
        <ng-container [ngSwitch]="slugPath | async">
            <course-using-the-course-support-article *ngSwitchCase="'/support/students/using-the-course'"></course-using-the-course-support-article>
            <course-settings-support-article *ngSwitchCase="'/support/students/using-the-course/settings'"></course-settings-support-article>
            <course-accessibility-support-article *ngSwitchCase="'/support/students/using-the-course/accessibility'"></course-accessibility-support-article>
            <course-trial-support-article *ngSwitchCase="'/support/students/using-the-course/trial'"></course-trial-support-article>
            <course-account-setup-support-article *ngSwitchCase="'/support/students/account-setup'"></course-account-setup-support-article>
            <course-getting-started-support-article *ngSwitchCase="'/support/organizations/getting-started'"></course-getting-started-support-article>
            <course-classes-support-article *ngSwitchCase="'/support/organizations/classes'"></course-classes-support-article>
            <course-add-class-support-article *ngSwitchCase="'/support/organizations/classes/add'"></course-add-class-support-article>
            <course-edit-class-support-article *ngSwitchCase="'/support/organizations/classes/edit'"></course-edit-class-support-article>
            <course-archive-class-support-article *ngSwitchCase="'/support/organizations/classes/archive'"></course-archive-class-support-article>
            <course-students-support-article *ngSwitchCase="'/support/organizations/students'"></course-students-support-article>
            <course-enroll-students-support-article *ngSwitchCase="'/support/organizations/students/enroll'"></course-enroll-students-support-article>
            <course-login-credentials-support-article *ngSwitchCase="'/support/organizations/students/login-credentials'"></course-login-credentials-support-article>
            <course-edit-student-support-article *ngSwitchCase="'/support/organizations/students/edit'"></course-edit-student-support-article>
            <course-reset-student-password-support-article *ngSwitchCase="'/support/organizations/students/reset-password'"></course-reset-student-password-support-article>
            <course-delete-student-support-article *ngSwitchCase="'/support/organizations/students/delete'"></course-delete-student-support-article>
            <course-restore-student-support-article *ngSwitchCase="'/support/organizations/students/restore'"></course-restore-student-support-article>
            <course-student-progress-support-article *ngSwitchCase="'/support/organizations/students/progress'"></course-student-progress-support-article>
            <course-licenses-support-article *ngSwitchCase="'/support/organizations/licenses'"></course-licenses-support-article>
            <course-enroll-order-support-article *ngSwitchCase="'/support/organizations/licenses/enroll-order'"></course-enroll-order-support-article>
            <course-advance-order-support-article *ngSwitchCase="'/support/organizations/licenses/advance-order'"></course-advance-order-support-article>
            <course-assign-licenses-support-article *ngSwitchCase="'/support/organizations/licenses/assign-licenses'"></course-assign-licenses-support-article>
            <course-student-order-support-article *ngSwitchCase="'/support/organizations/licenses/student-order'"></course-student-order-support-article>
            <course-instructors-support-article *ngSwitchCase="'/support/organizations/instructors'"></course-instructors-support-article>
            <course-difference-instructor-administrator-support-article *ngSwitchCase="'/support/organizations/instructors/instructor-administrator'"></course-difference-instructor-administrator-support-article>
            <course-add-instructor-support-article *ngSwitchCase="'/support/organizations/instructors/add'"></course-add-instructor-support-article>
            <course-assign-instructor-support-article *ngSwitchCase="'/support/organizations/instructors/assign'"></course-assign-instructor-support-article>
            <course-edit-instructor-support-article *ngSwitchCase="'/support/organizations/instructors/edit'"></course-edit-instructor-support-article>
            <course-reset-instructor-password-support-article *ngSwitchCase="'/support/organizations/instructors/reset-password'"></course-reset-instructor-password-support-article>
            <course-delete-instructor-support-article *ngSwitchCase="'/support/organizations/instructors/delete'"></course-delete-instructor-support-article>
            <course-restore-instructor-support-article *ngSwitchCase="'/support/organizations/instructors/restore'"></course-restore-instructor-support-article>
            <course-instructor-course-access-support-article *ngSwitchCase="'/support/organizations/instructors/course-access'"></course-instructor-course-access-support-article>
            <course-exercises-support-article *ngSwitchCase="'/support/organizations/exercises'"></course-exercises-support-article>
            <course-add-exercise-support-article *ngSwitchCase="'/support/organizations/exercises/add'"></course-add-exercise-support-article>
            <course-exercise-access-support-article *ngSwitchCase="'/support/organizations/exercises/access'"></course-exercise-access-support-article>
            <course-edit-exercise-support-article *ngSwitchCase="'/support/organizations/exercises/edit'"></course-edit-exercise-support-article>
            <course-delete-exercise-support-article *ngSwitchCase="'/support/organizations/exercises/delete'"></course-delete-exercise-support-article>
            <course-resources-support-article *ngSwitchCase="'/support/organizations/resources'"></course-resources-support-article>
        </ng-container>

        <ul *ngIf="article.children && article.children.length > 0" class="childArticles">
            <li *ngFor="let child of article.children">
                <a [routerLink]="child.slug">
                    <mat-icon>arrow_forward</mat-icon> {{ child.title }}
                </a>
            </li>
        </ul>
    </div>
</div>
